import { render, staticRenderFns } from "./FormIncidentCoupAttemptDetail.vue?vue&type=template&id=3b27dfb1&scoped=true&"
import script from "./FormIncidentCoupAttemptDetail.vue?vue&type=script&lang=js&"
export * from "./FormIncidentCoupAttemptDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormIncidentCoupAttemptDetail.vue?vue&type=style&index=0&id=3b27dfb1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b27dfb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b27dfb1')) {
      api.createRecord('3b27dfb1', component.options)
    } else {
      api.reload('3b27dfb1', component.options)
    }
    module.hot.accept("./FormIncidentCoupAttemptDetail.vue?vue&type=template&id=3b27dfb1&scoped=true&", function () {
      api.rerender('3b27dfb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/incident/handling/FormIncidentCoupAttemptDetail.vue"
export default component.exports